import * as React from 'react'
import type { SVGProps } from 'react'
import { cn } from '../../../utils/utils'
const SvgCircleWavyCheck = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 32 32"
        {...props}
        className={cn('inline-block relative -top-px', props.className)}
    >
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6.808 25.192c-1.15-1.15-.388-3.565-.973-4.98C5.228 18.743 3 17.562 3 16s2.228-2.744 2.835-4.211c.585-1.415-.178-3.83.973-4.981 1.15-1.15 3.566-.388 4.98-.973C13.257 5.228 14.438 3 16 3s2.744 2.228 4.211 2.835c1.416.585 3.83-.178 4.981.973 1.15 1.15.388 3.566.973 4.98C26.773 13.257 29 14.438 29 16s-2.228 2.744-2.835 4.211c-.585 1.416.178 3.83-.973 4.981-1.15 1.15-3.565.388-4.98.973C18.743 26.773 17.562 29 16 29s-2.744-2.228-4.211-2.835c-1.415-.585-3.83.178-4.981-.973"
        />
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="m21.5 13-7.333 7-3.667-3.5" />
    </svg>
)
export default SvgCircleWavyCheck
